import React, { useState } from 'react';
import { styles } from './PremiumDeliveryTile.css';
import { JBButton } from '@jbhi-fi/lanyard-ui';
import { PremiumDeliveryMoreInfoPopout } from '../../../../checkout/premiumDelivery/PremiumDeliveryMoreInfoPopout/PremiumDeliveryMoreInfoPopout';
import { getPremiumDeliveryMoreInfoProps } from '../../../../checkout/premiumDelivery/PremiumDeliveryMoreInfoPopout/getPremiumDeliveryMoreInfoProps';
import PopoutDrawer from '../../../../popout-drawer/PopoutDrawer';
import { getProductType, premiumDeliveryOptionValues } from '@jbhi-fi/utils/src/premiumDelivery/premiumDelivery';
import { DeliveryOption } from '../../../utils/types';

export const PremiumDeliveryTile = ({ deliveryOptions }: { deliveryOptions: Array<DeliveryOption> | undefined }) => {
  const [isPremiumDeliveryPopoutVisible, setIsPremiumDeliveryPopoutVisible] = useState<boolean>(false);
  const handleClickMoreInfo = () => {
    setIsPremiumDeliveryPopoutVisible(!isPremiumDeliveryPopoutVisible);
  };
  const product_group =
    window.Jbhifi['product.metafields']?.online_product?.value?.ProductGroup?.Description?.toLowerCase() ?? '';

  const isPremiumDeliveryChangesEnabled = window.Jbhifi?.premiumDeliveryConfig?.isPremiumDelievryChangesEnabled ?? true;
  const hasMultipleAddOns =
    (deliveryOptions?.filter(option => premiumDeliveryOptionValues.includes(option.experienceName)).length ?? 0) > 1;
  const title = `Delivery add-on${hasMultipleAddOns ? 's' : ''} available`;
  return (
    <div className={styles.container}>
      <PopoutDrawer
        title=""
        anchor="right"
        isOpen={isPremiumDeliveryPopoutVisible}
        onClose={() => handleClickMoreInfo()}
      >
        <PremiumDeliveryMoreInfoPopout
          {...getPremiumDeliveryMoreInfoProps(
            getProductType(product_group),
            isPremiumDeliveryChangesEnabled,
            deliveryOptions
          )}
        />
      </PopoutDrawer>
      <div>
        <p className={styles.title} data-testid="premium-delivery-tile">
          {title}
        </p>
        <p className={styles.description}>
          {hasMultipleAddOns
            ? 'Get it delivered, plugged-in, and packaging taken away. Old product removal also available.'
            : 'Get your old disconnected product of a similar type and size taken away'}{' '}
          <JBButton type="link" onClick={handleClickMoreInfo} classes={styles.link}>
            More information
          </JBButton>
        </p>
      </div>
    </div>
  );
};
